import { render, staticRenderFns } from "./Email-sella-transaction.vue?vue&type=template&id=6439cc19&"
import script from "./Email-sella-transaction.vue?vue&type=script&lang=js&"
export * from "./Email-sella-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports